import React from 'react'
import { NavLink } from "react-router-dom";
import logo from '../assets/img/IotDBNavbar.png'
const Footer = () => {
    return (
        <footer className="footer mt-5">



            <div className="columns">

                <div className="column">

                    <img src={logo} alt="footer-logo" id='img-foot' />
                    <h4 className="bd-footer-title 
                 has-text-weight-medium
                 has-text-left">
                        Ayres IoT Dashboard
                    </h4>


                    <p className="bd-footer-link 
                has-text-left">
                        An app that make you posible to monitor temperature & humidity anywhen also everywhere
                    </p>

                </div>


                <div className="column">
                    <h4 className="bd-footer-title 
                 has-text-weight-medium 
                 has-text-justify">
                        Explore
                    </h4>


                    <p className="bd-footer-link">
                        <NavLink className="navLink" to={"/home"}>
                            <span className="icon-text">
                                <span>Home</span>
                            </span>
                        </ NavLink>
                        <br />
                        <NavLink className="navLink" to={"/dashboard"}>
                            <span className="icon-text">
                                <span>Dashboard</span>
                            </span>
                        </ NavLink>
                        <br />
                        <NavLink className="navLink" to={"/sensors"}>
                            <span className="icon-text">
                                <span>Report</span>
                            </span>
                        </ NavLink>
                    </p>

                </div>


                <div className="column">
                    <h4 className="bd-footer-title
                 has-text-weight-medium
                 has-text-justify">
                        Contact us
                    </h4>

                    <p className="bd-footer-link">
                        <a href="mailto:enginering.ayres@gmail.com">
                            <span className="icon-text">
                                <span>Email</span>
                            </span>
                        </a>
                        <br />
                        <a href='tel:+6289509465293'>
                            <span className="icon-text">
                                <span>Call Us</span>
                            </span>
                        </a>
                        <br />
                    </p>
                </div>
            </div>
            <div className="content has-text-centered">
                <p className='title is-7'>Copyright © <a href='https://ayres-engineering.netlify.app/' target='_blank' rel="noreferrer">Ayres Engineering</a></p>

            </div>

        </footer>
    )
}

export default Footer